<div class="no-patient-error-container">
  <div class="logo-container">
    <div class="logo"></div>
    <span style="font-size:3.39rem; margin-left: 2.85rem;">IntelliSpace Precision Medicine™</span>
  </div>
  <div class="no-patient-error-message">
    <span class="msg" >{{errorMessage}}</span>
  </div>
  <div class="no-patient-error-footer">
    <small style="float: left">Philips North America LLC, 2 Canal Park, Cambridge, MA 02141 USA</small>
  </div>
</div>
